import { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import { Typo, TypoVariant } from '@/components/common/typography'
import {
  getDiff,
  getDuration,
  getDurationDays,
  getDurationHours,
  getDurationMinutes,
  getDurationSeconds,
} from '@/utils/utilDate'

type ProductDetailTimeSaleProps = {
  endedAt: string
}

const ProductDetailTimeSale = ({ endedAt }: ProductDetailTimeSaleProps) => {
  const [hasEnded, setHasEnded] = useState<boolean>(false)
  const [timeLeft, setTimeLeft] = useState<string>('')
  const { color } = useTheme()

  useEffect(() => {
    const updateCountdown = () => {
      const diff = getDiff(endedAt)
      const duration = getDuration(diff)
      if (duration.asSeconds() <= 0) {
        setHasEnded(true)
      } else {
        const days = Math.floor(getDurationDays(duration)).toString().padStart(2, '0')
        const hours = getDurationHours(duration).toString().padStart(2, '0')
        const minutes = getDurationMinutes(duration).toString().padStart(2, '0')
        const seconds = getDurationSeconds(duration).toString().padStart(2, '0')

        setTimeLeft(
          duration.asDays() > 1 ? `${days}일 ${hours}:${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`
        )
      }
    }

    const interval = setInterval(updateCountdown, 1000)
    return () => clearInterval(interval)
  }, [endedAt])

  return (
    <Typo variant={TypoVariant.Body1SemiBold} color={!timeLeft ? color.gray900 : color.grayWhite}>
      {hasEnded ? '타임 세일 종료' : `${timeLeft} 남음`}
    </Typo>
  )
}

export default ProductDetailTimeSale
